import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Configuration } from 'src/Configuration';

export const zipDownloadApiSlice = createApi({
  reducerPath: 'zipDownloadApi',
  baseQuery: fetchBaseQuery({
    baseUrl: Configuration.ApiUrl,
    responseHandler: async (response) => {
      const buffer = await response.arrayBuffer();
      return buffer;
    },
    prepareHeaders(headers) {
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getImagesZipFileForOrder: builder.query<Blob, string>({
      query: (orderId) => `/eventsshop/orders/${orderId}/photos/zip`,
    }),
  }),
});

export const { useLazyGetImagesZipFileForOrderQuery } = zipDownloadApiSlice;
